import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class VersionConflictError extends CodedError {
  static get errorName() {
    return errorCodes.versionConflictError.code;
  }

  constructor(message: string = errorCodes.versionConflictError.message) {
    super(message);
    this.code = errorCodes.versionConflictError.code;
    this.status = errorCodes.versionConflictError.status;
    this.message = `${message} ${errorCodes.versionConflictError.code}`;
    this.name = errorCodes.versionConflictError.name;
  }
}
